import { clone } from "ramda";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { loadState } from "../route/LocalStorage";
import {
  expireSession,
  login,
  resetUser,
  setUserSSO,
  storeLocalStorageUser,
  updateLastUsed
} from "./actions";
import { NotLoggedInUser, User } from "./types";

export enum STATES {
  ERROR = "error",
  INITIAL = "initial",
  LOADED = "loaded",
  LOADING = "loading"
}

export interface LoggedInState {
  user: User;
}

export interface ErrorLoggingInState {
  user: User;
}

export interface LoggingInState {
  user: User;
}

export interface NotLoggedInState {
  user: User;
}

export type LoginState =
  | LoggedInState
  | ErrorLoggingInState
  | LoggingInState
  | NotLoggedInState;

const userReducer = reducerWithInitialState<Readonly<LoginState>>({
  user: NotLoggedInUser
})
  .case(login.async.started, state => ({
    user: clone(NotLoggedInUser)
  }))
  .case(login.async.done, (state, { result: user }) => ({
    user
  }))
  .case(login.async.failed, (state, { error: user }) => {
    const newUser = clone(NotLoggedInUser);
    newUser.errorMessage = user.errorMessage || "";
    return {
      user: newUser
    };
  })
  .case(setUserSSO, (state, { issuedAt, expiresIn, access_token, userId }) => {
    const user = {
      username: "",
      credentials: {
        accessToken: `${access_token}`,
        expiresIn: `${expiresIn}`,
        idToken: "",
        issuedAt: `${issuedAt}`,
        refreshToken: "",
        tokenType: "jwt",
        lastUsed: ""
      },
      isAuthenticated: true,
      errorMessage: "",
      isBankAnalyst: true,
      hasManagedService: true,
      userId: `${userId}`,
      qaTeams: []
    };
    return {
      user
    };
  })
  .case(resetUser, (state, { errorMessage }) => {
    const user = clone(NotLoggedInUser);
    user.errorMessage = errorMessage || "";
    return {
      user
    };
  })
  .case(expireSession.async.done, (state, { result: user }) => ({
    user
  }))
  .case(expireSession.async.failed, (state, { error: userWithError }) => ({
    user: userWithError
  }))
  .case(updateLastUsed, (state, { lastUsed }) => {
    const newUser = clone(state.user);
    newUser.credentials.lastUsed = lastUsed;
    return {
      user: newUser
    };
  })
  .case(storeLocalStorageUser, state => {
    const lsState = loadState();
    if (!lsState) {
      return {
        user: state.user
      };
    }

    return {
      user: lsState.user.user
    };
  });

export default userReducer;



// WEBPACK FOOTER //
// ./src/login/reducer.ts